

export const questionnaire = {
  "questionnaire_title": "Questionnaires",
  "questionnaire_point": "points",
  "questionnaire_resume": "Resume",
  "questionnaire_card_progress": "{{answered}} of {{total}}",
  "questionnaire_selected_count_one": "{{count}} selected",
  "questionnaire_selected_count_other": "{{count}} selected",
  "questionnaire_about": "Questionnaire about {{name}}",
  "questionnaire_questionnaire": "Questions",
  "questionnaire_minutes": "minutes",
  "questionnaire_continue": "Continue",
  "questionnaire_start": "Start",
  "questionnaire_finish": "Finish",
  "questionnaire_completed": "Questionnaire completed, thank you!",
  "questionnaire_preview_title": "Questionnaire simulation",
  "questionnaire_preview_banner": "Simulation — your answers are not saved",
  "questionnaire_preview_loading": "Loading simulation…",
  "questionnaire_preview_invalid": "This simulation link is invalid or has expired.",
  "questionnaire_preview_error": "Could not load the questionnaire (the selected language may not be configured for this study).",
  "questionnaire_preview_empty": "This questionnaire has no questions yet.",
  "questionnaire_preview_done_title": "End of questionnaire",
  "questionnaire_preview_done_score": "Score: {{score}}",
  "questionnaire_preview_restart": "Restart",
  "questionnaire_preview_lang_default": "Study language",
  "questionnaire_preview_lang_fr": "French",
  "questionnaire_preview_lang_en": "English",
  "questionnaire_preview_lang_es": "Spanish",
  "questionnaire_preview_lang_ar": "Arabic",
  "content_preview_chrome": "App header & navbar",
  "questionnaire_identity_conflict": "This value is already used by another participant. Your answer was not saved.",
  "questionnaire_identity_unknown_external_id": "Case number not recognized — check the number given by the team. Your answer was not saved."
}